<template>
    <div>
        
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    created(){
        if(window.location.href.split('?')[1]){
            let query = window.location.href.split('?')[1]
            let vars = query.split('&')
            let pars=[]
            for(var i = 0;i<vars.length;i++){
                pars[i]=vars[i].split('=')[1]
            }
            let signTime = new Date().getTime()
            this.$store.commit('nowsign', signTime)
            window.open(`/url/exportRequestLog?startDate=${pars[0]}&endDate=${pars[1]}&sign=${this.$store.state.sign}&auth_Code=${this.$store.state.authCode}&sign_time=${signTime}&route=${this.$store.state.newroute}&factory_id=${this.$store.state.factoryId}`, '_blank')
        }
    }
}
</script>